import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      // Vermeide unnötige 401-Probe, wenn keinerlei Token-Indikator vorhanden ist.
      const hasToken = !!localStorage.getItem("fmp_token");
      const hasCookieHint =
        typeof document !== "undefined" &&
        document.cookie
          .split(";")
          .some((c) => c.trim().startsWith("fmp_session="));
      if (!hasToken && !hasCookieHint) {
        setUser(null);
        setLoading(false);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
      } catch {
        setUser(null);
        // Aufräumen, wenn Token nicht mehr gültig
        localStorage.removeItem("fmp_token");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("fmp_token", data.token);
    // Nicht-httpOnly Cookie als Hint für spätere Session-Restore (nur Existenz, kein Wert!)
    if (typeof document !== "undefined") {
      document.cookie = "fmp_session=1; path=/; max-age=604800; samesite=lax";
    }
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.token) localStorage.setItem("fmp_token", data.token);
    if (typeof document !== "undefined") {
      document.cookie = "fmp_session=1; path=/; max-age=604800; samesite=lax";
    }
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* Fehler beim Server-Logout ignorieren – lokal aufräumen ist wichtiger */
    }
    localStorage.removeItem("fmp_token");
    if (typeof document !== "undefined") {
      document.cookie = "fmp_session=; path=/; max-age=0; samesite=lax";
    }
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
